import { atom } from "recoil";

export const createPropertyOwnerDrawerState = atom({
  key: "createPropertyOwnerDrawerState", // unique ID (with respect to other atoms/selectors)
  default: null, // default value (aka initial value)
});
